import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./course.page.scss";
import CourseComponent from "../../components/course/course.cmp";
import navigationService from "../../services/navigation/navigation.service";
import { FetchTranscripts } from "../../helpers/fetch.transcripts";
import { AccountCommander } from "../../store/commanders/account.commander";
import courseComander from "../../store/commanders/course.comander";
import { useTranslation } from "react-i18next";
import { loadSpanishCourse } from "../../store/actions/course.translation.action";
import { selectDisplayedCourse } from "../../helpers/course.translation";
import { searchTree } from "../../store/helper/tree.helper";

const CoursePage = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => {
    return state.account.userData;
  });

  const course = useSelector((state: any) => state.course);
  const currentLanguage = useSelector((state: any) => state.application.currentLanguage);
  const displayedCourse = useSelector(selectDisplayedCourse);
  const displayedSection = useMemo(
    () => displayedCourse
      ? searchTree(displayedCourse, course.selectedSection?.id) || displayedCourse
      : null,
    [displayedCourse, course.selectedSection?.id],
  );
  const canAccessCourse = useMemo(() => {
    return !!userData?.valid_subscription || userData?.state === "AL";
  }, [userData?.state, userData?.valid_subscription]);

  const userName = userData.first_name + " " + userData.last_name;
  const getTranscripts = useCallback((lesson) => FetchTranscripts(lesson), []);

  useEffect(() => {
    if (canAccessCourse && currentLanguage === "es" && course.data?.id) {
      dispatch(loadSpanishCourse());
    }
  }, [dispatch, canAccessCourse, currentLanguage, course.translationGeneration, course.data?.id]);

  useEffect(() => {
    if (!course || !course.data) {
      courseComander.cmd_get_course();
    }
  }, [course?.id]);

  useEffect(() => {
    if (course && course.selectedSection) {
      courseComander.cmd_get_certificates();
    }
  }, [course?.data]);

  useEffect(() => {
    if (
      canAccessCourse &&
      course?.data &&
      !course.data.courseConsentAccepted
    ) {
      navigationService.navigate("/course-consent");
    }
  }, [canAccessCourse, course?.data?.courseConsentAccepted]);

  const submitFeedback = (feedbackData) =>
    AccountCommander.cmd_submit_survey(feedbackData);

  if (!canAccessCourse) {
    return (
      <div className="course-empty-state">
        <div className="course-empty-state__card">
          <span className="course-empty-state__eyebrow">{t("course.access")}</span>
          <h1>{t("course.purchaseTitle")}</h1>
          <p>{t("course.purchaseDescription")}</p>
          <div className="course-empty-state__actions">
            <button
              type="button"
              className="cf-navbar__links--link cf-navbar__links--link-primary"
              onClick={() => navigationService.navigate("/payment?product=course")}
            >
              {t("course.buyOnly")}
            </button>
            <button
              type="button"
              className="course-empty-state__secondary-btn"
              onClick={() => navigationService.navigate("/background")}
            >
              {t("course.goToBackground")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <CourseComponent
      course={displayedCourse}
      selected={displayedSection}
      userCertificates={course ? course.certificates : null}
      userName={userName}
      state={userData.state}
      isUserAdmin={userData.is_admin}
      getTranscripts={getTranscripts}
      showFeedbackForStudent={!userData.feedback_submitted}
      showCongrats={course.showCongrats}
      submitFeedback={submitFeedback}
    />
  );
};
export default CoursePage;
